import { render, staticRenderFns } from "./ReportesDescarga.vue?vue&type=template&id=be3418ac&"
import script from "./ReportesDescarga.vue?vue&type=script&lang=js&"
export * from "./ReportesDescarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports